export default __webpack_public_path__ + "static/media/70.60f8e71f.jpeg";